import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';

export class RefMvtTypeVin {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code' },
        libelle: { key: 'libelle' },
        dateDebut: { key: 'dateDebut', converter: new DateConverter() },
        dateFin: { key: 'dateFin', converter: new DateConverter() }
    };

    id: number;
    code: string;
    libelle: string;
    dateDebut: moment.Moment;
    dateFin: moment.Moment;
}
